import * as Yup from 'yup';

export default Yup.object().shape({
  address: Yup.string().nullable(),
  exteriorNumber: Yup.string().nullable(),
  interiorNumber: Yup.string().nullable(),
  zipCode: Yup.string()
    .matches(/^[0-9]{5}$/, 'SCHEMA_ERRORS.ZIP_CODE_INVALID')
    .nullable(),
  neighborhood: Yup.string().nullable(),
  municipality: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable()
});
